var CardBody = function CardBody(_ref) {
  var children = _ref.children,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? true : _ref$padding,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-body ".concat(padding && 'card-body__padding', " ").concat(className)
  }, children);
};
export default CardBody;